import useTab from "./tab"
// 使用pinia做状态管理
export default {
  useTab
}
